import {
	API_DATE_FORMAT,
	API_DATE_FORMAT_WITH_TIME,
	API_DATE_FORMAT_WITH_TIME_UTC,
	API_DATE_FORMAT_WITH_DATE_TIME_UTC,
} from 'config/api';
import moment from 'moment';

export function toMoment(value, format = API_DATE_FORMAT) {
	return moment(value, format);
}

export function toUTCfromMoment(
	value,
	offset,
	format = API_DATE_FORMAT_WITH_TIME_UTC
) {
	return moment.utc(value).add(offset).format(format);
}

export function toMomentFromUtc(value, format = API_DATE_FORMAT_WITH_TIME) {
	return moment.utc(value, format).local();
}

export function toMomentFromUtcDate(value, format = API_DATE_FORMAT) {
	return moment.utc(value, format).local();
}

export function toMomentFromUtcDateTime(
	value,
	format = API_DATE_FORMAT_WITH_DATE_TIME_UTC
) {
	return moment.utc(value, format).local();
}



// WEBPACK FOOTER //
// ./src/api/helpers/dates.js